import { render, staticRenderFns } from "./DollarQuotationsTable.vue?vue&type=template&id=0c1865f2&"
import script from "./DollarQuotationsTable.vue?vue&type=script&lang=js&"
export * from "./DollarQuotationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports